import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromUsers from './users/users.reducer';
import * as fromBrokers from './brokers/brokers.reducer';
import * as fromTickets from './tickets/tickets.reducer';
import * as fromLogs from './logs/logs.reducer';
import * as fromHealth from './health/health.reducer';

export interface AppState {
  users: fromUsers.UsersState;
  brokers: fromBrokers.BrokersState;
  tickets: fromTickets.TicketsState;
  logs: fromLogs.LogsState;
  health: fromHealth.HealthState;
}

export const reducers: ActionReducerMap<AppState> = {
  users: fromUsers.reducer,
  brokers: fromBrokers.reducer,
  tickets: fromTickets.reducer,
  logs: fromLogs.reducer,
  health: fromHealth.reducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
